<script lang="ts">

import Component from 'vue-class-component'

import { getSnowflakeDatabases } from '@/api'
import SnowflakeDropdown from '@/components/admin/upload/snowflake/SnowflakeDropdown.vue'
import { HttpError } from '@/errors'

@Component
export default class SnowflakeDropdownDatabases extends SnowflakeDropdown {
  name = 'database'

  get canFetchData () {
    return Boolean(this.username && this.password && this.account)
  }

  async fetchData () {
    this.fetching = true
    try {
      this.response = await getSnowflakeDatabases({
        user: this.username,
        password: this.password,
        account: this.account,
        warehouse: this.warehouse,
      })
    } catch (e) {
      if (e instanceof HttpError && e.status === 400) {
        const warning = await e.getJson()
        this.$emit('error', warning)
      } else {
        throw e
      }
    }
    this.fetching = false
  }
}

</script>
